<div class="min-h-screen bg-[#F9F8F7] relative">
  <div [ngClass]="{ 'mb-16': !isLoggedIn }">
    <!-- HERO section -->
    <section class="relative w-full h-[349px]">
      <div class="absolute inset-0">
        <img
          src="assets/images/hero-banner.png"
          alt="Background"
          class="w-full h-full object-cover"
        />
        <div class="absolute inset-0 bg-black/40"></div>
      </div>

      <div class="relative -z-1 flex flex-col items-center justify-center h-full px-4 text-center">
        <h1
          class="text-white font-poppins text-4xl sm:text-5xl lg:text-[64px] font-semibold leading-[110%] mb-4 text-center"
        >
          Due Diligence Made Simple
        </h1>
        <p
          class="text-[#F9FAFB] font-poppins text-sm sm:text-base font-normal leading-[110%] tracking-[0.08px] max-w-[1025px]"
        >
          Verify organizations and NGOs instantly using their PAN number. Access comprehensive
          compliance data, financial reports, and legal status in one platform.
        </p>
      </div>
    </section>

    <!-- Search section -->
    <section class="relative -mt-8 px-4 sm:px-6 lg:px-20 mb-16">
      <div class="relative max-w-[652px] mx-auto">
        <div class="w-full" id="search-container">
          <app-common-search
            placeholder="Enter PAN number"
            [(searchTerm)]="currentSearchTerm"
            [debounceTime]="1000"
            (searchChange)="onSearchChange($event)"
            (searchFocus)="onSearchFocus($event)"
          ></app-common-search>
        </div>

        <p
          *ngIf="showErrorMessage"
          class="text-red-500 font-poppins text-sm font-normal tracking-[0.048px] text-start inline-block mt-2"
        >
          {{ errorMessage }}
        </p>
        <p
          *ngIf="!showErrorMessage"
          class="text-[#374151] font-poppins text-sm font-normal tracking-[0.048px] text-start inline-block mt-2"
        >
          Format: 5 letters, 4 digits, 1 letter (e.g., ABCDE1234F)
        </p>
      </div>
    </section>

    <!-- Features section -->
    <section class="px-4 sm:px-6 lg:px-20 pb-16">
      <div class="max-w-[1351px] mx-auto">
        <div class="flex flex-col items-center gap-4 mb-12">
          <h2
            class="text-[#811622] text-center font-poppins text-2xl sm:text-[26px] font-semibold leading-[110%]"
          >
            Complete Due Diligence Platform
          </h2>
          <p
            class="text-[#0E1116] text-center font-poppins text-base font-normal leading-[110%] tracking-[0.08px] max-w-[583px]"
          >
            Everything you need to verify and analyze organizations, all in one place.
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div
            class="bg-white rounded-xl border border-[rgba(255,255,255,0.01)] shadow-[0_1px_4px_0_rgba(0,0,0,0.16)] p-6 flex flex-col items-center text-center gap-2"
          >
            <div class="w-[72px] h-[72px] mb-2">
              <img src="assets/icons/info-orange.svg" alt="info-icon" class="w-full h-full" />
            </div>
            <h3
              class="text-[#060606] font-poppins text-base font-semibold leading-[110%] tracking-[0.08px]"
            >
              Basic Information
            </h3>
            <p
              class="text-[#4B4B4B] text-center font-inter text-xs font-normal leading-[110%] tracking-[0.048px]"
            >
              Get comprehensive organizational details including registration status, directors, and
              address verification.
            </p>
          </div>

          <div
            class="bg-white rounded-xl border border-[rgba(255,255,255,0.01)] shadow-[0_1px_4px_0_rgba(0,0,0,0.16)] p-6 flex flex-col items-center text-center gap-2"
          >
            <div class="w-[72px] h-[72px] mb-2">
              <img src="assets/icons/money-bag.svg" alt="money-bag-icon" class="w-full h-full" />
            </div>
            <h3
              class="text-[#060606] font-poppins text-base font-semibold leading-[110%] tracking-[0.08px]"
            >
              Financial & Legal Compliance
            </h3>
            <p
              class="text-[#4B4B4B] text-center font-inter text-xs font-normal leading-[110%] tracking-[0.048px]"
            >
              Access compliance reports, tax filings, legal proceedings, and regulatory status in
              one place.
            </p>
          </div>

          <div
            class="bg-white rounded-xl border border-[rgba(255,255,255,0.01)] shadow-[0_1px_4px_0_rgba(0,0,0,0.16)] p-6 flex flex-col items-center text-center gap-2"
          >
            <div class="w-[72px] h-[72px] mb-2">
              <img src="assets/icons/database.svg" alt="database-icon" class="w-full h-full" />
            </div>
            <h3
              class="text-[#060606] font-poppins text-base font-semibold leading-[110%] tracking-[0.08px]"
            >
              Raw Data Analysis
            </h3>
            <p
              class="text-[#4B4B4B] text-center font-inter text-xs font-normal leading-[110%] tracking-[0.048px]"
            >
              Dive deep into source documents and raw data for thorough due diligence verification.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- How Radar Works section -->
    <section class="bg-white px-4 sm:px-6 lg:px-20 py-16">
      <div class="max-w-[1351px] mx-auto">
        <div class="flex flex-col gap-4 mb-12">
          <h2
            class="text-[#811622] font-poppins text-2xl sm:text-[26px] font-semibold leading-[110%]"
          >
            How Radar Works
          </h2>
          <p
            class="text-[#0E1116] font-poppins text-base font-normal leading-[110%] tracking-[0.08px]"
          >
            Three simple steps to complete your due diligence verification.
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 items-start">
          <div class="flex flex-col items-center text-center gap-6">
            <div class="relative w-full flex justify-center items-center">
              <div
                class="w-[89px] h-[89px] rounded-full bg-[#F58634] flex items-center justify-center"
              >
                <span class="text-white font-poppins text-[47px] font-normal leading-[110%]"
                  >1</span
                >
              </div>
              <img
                src="assets/icons/stroke-left-arrow.svg"
                alt="Stroke Left Arrow"
                class="hidden md:block absolute right-[-100px] top-1/2 -translate-y-1/2"
              />
            </div>
            <div class="flex flex-col gap-4">
              <h3
                class="text-[#0E1116] font-poppins text-[19px] font-medium leading-[110%] tracking-[0.029px]"
              >
                Enter PAN Number
              </h3>
              <p
                class="text-[#0E1116] font-poppins text-sm font-normal leading-[110%] tracking-[0.035px]"
              >
                Input the organization's PAN number to begin verification.
              </p>
            </div>
          </div>

          <div class="flex flex-col items-center text-center gap-6">
            <div class="relative w-full flex justify-center items-center">
              <div
                class="w-[89px] h-[89px] rounded-full bg-[#F58634] flex items-center justify-center"
              >
                <span class="text-white font-poppins text-[47px] font-normal leading-[110%]"
                  >2</span
                >
              </div>
              <img
                src="assets/icons/stroke-left-arrow.svg"
                alt="Stroke Left Arrow"
                class="hidden md:block absolute right-[-100px] top-1/2 -translate-y-1/2"
              />
            </div>
            <div class="flex flex-col gap-4">
              <h3
                class="text-[#0E1116] font-poppins text-[19px] font-medium leading-[110%] tracking-[0.029px]"
              >
                Analyze Data
              </h3>
              <p
                class="text-[#0E1116] font-poppins text-sm font-normal leading-[110%] tracking-[0.035px]"
              >
                Our system fetches and analyzes data from multiple sources.
              </p>
            </div>
          </div>

          <div class="flex flex-col items-center text-center gap-6">
            <div
              class="w-[89px] h-[89px] rounded-full bg-[#F58634] flex items-center justify-center"
            >
              <span class="text-white font-poppins text-[47px] font-normal leading-[110%]">3</span>
            </div>
            <div class="flex flex-col gap-4">
              <h3
                class="text-[#0E1116] font-poppins text-[19px] font-medium leading-[110%] tracking-[0.029px]"
              >
                Get Report
              </h3>
              <p
                class="text-[#0E1116] font-poppins text-sm font-normal leading-[110%] tracking-[0.035px]"
              >
                Review comprehensive due diligence report with insights.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!--  Get Started Section -->
  <ng-container *ngIf="!isLoggedIn">
    <div
      class="w-[90vw] mx-auto bg-white rounded-lg drop-shadow-lg px-4 sm:px-6 lg:px-20 py-10 flex justify-between items-center absolute left-0 right-0 translate-y-[-50%]"
    >
      <div class="text">
        <h1 class="text-2xl font-semibold text-radar-primary mb-0">Ready to Get Started?</h1>
        <p class="text-gray-500 text-sm mb-0">
          Start your due diligence verification today. No credit card required.
        </p>
      </div>
      <app-common-button
        text="Get Started"
        variant="primary"
        (onClick)="scrollToSearchContainer()"
      ></app-common-button>
    </div>
  </ng-container>
</div>
